module.exports = __webpack_public_path__ + "static/media/1 Colorado Girl.27857cc7.mp3";